"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableContainer.default;
  }
});

var _TableContainer = _interopRequireDefault(require("./TableContainer"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/TableContainer/index.js
// module id = 167
// module chunks = 0